import { render, staticRenderFns } from "./deviceCanvasTip.vue?vue&type=template&id=782f874a&scoped=true&"
import script from "./deviceCanvasTip.vue?vue&type=script&lang=js&"
export * from "./deviceCanvasTip.vue?vue&type=script&lang=js&"
import style0 from "./deviceCanvasTip.vue?vue&type=style&index=0&id=782f874a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782f874a",
  null
  
)

export default component.exports